module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<p class="product_search_description">\n    ';
 if (showSearchDescription) { ;
__p += '\n      ' +
((__t = ( I18n.t('uploader.review_submission.product_tagging_description') )) == null ? '' : __t) +
'\n    ';
 } ;
__p += '\n  </p>\n<div id="social_review_wrapper"></div>\n<button id="next" class="bottom_button">\n  ' +
((__t = ( I18n.t('uploader.buttons.next') )) == null ? '' : __t) +
'\n</button>\n';

}
return __p
}